<template>
  <a v-if="category && category.name" @click="navigateToCategory" class="dapp-category-label ">{{ category.name }}</a>
</template>

<script>
  import * as router from '../router'

  export default {
    name: 'DAppCategoryLabel',
    props: ['category'],
    methods: {
      navigateToCategory () {
        router.navigateToCategory(this.category)
      }
    }
  }
</script>

<style lang="scss" scoped>

  .dapp-category-label {
    display: inline-block;
    background-color: #888888;
    color: white !important;
    padding: 3px 5px;
    border-radius: 2px;
    font-size: 0.8em;
  }

</style>



// WEBPACK FOOTER //
// src/widgets/DAppCategoryLabel.vue